export const indexPrototypeConfig = {
  scrollSensitivity: 1.35,
  scrollDamping: 0.24,
  centerZoneRatio: 0.1,
  centerHysteresisPx: 20,
  artworkHoverScale: 1.045,
  artworkHoverDurationMs: 200,
  pointerMoveX: 24,
  pointerMoveY: 36,
  contentFadeInMs: 700
};
